import { render } from "./FileUploadDropzone.vue?vue&type=template&id=25ea0f38&scoped=true"
import script from "./FileUploadDropzone.vue?vue&type=script&lang=js"
export * from "./FileUploadDropzone.vue?vue&type=script&lang=js"

import "./FileUploadDropzone.vue?vue&type=style&index=0&id=25ea0f38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ea0f38"]])

export default __exports__